import { Button } from "antd";
import { Link, useLocation, useParams } from "react-router-dom";
import EditButtonIcon from "../../../../../assets/icons/EditButtonIcon";
import { backLink } from "../../../../../utils/utils";
import { employeeDetailsList } from "../../EmployeesDetails";

interface EditButtonEmployeeProps {
  type: (typeof employeeDetailsList)[number] | number;
}

export default function EditButtonEmployee({ type }: EditButtonEmployeeProps) {
  const location = useLocation();
  const { viewId } = useParams();
  // const { authInfo } = useAppSelector((state) => state.auth);

  // if (authInfo?.role !== "Admin") {
  //   return null;
  // }

  if (viewId) {
    return (
      <div className="mt-6 mb-1.5">
        <Link
          to={`${backLink(location.pathname, 2)}/edit/${viewId}?type=${type}`}
        >
          <Button
            className="outline-button-primary !min-w-[151px] h-10"
            icon={<EditButtonIcon />}
          >
            Edit
          </Button>
        </Link>
      </div>
    );
  }

  return null;
}
